import Slider from "./index";

const BannerGate = () => <Slider />;

export default BannerGate;
